import { BrowserInfo } from '@is24/is24-checkout-js/dist/@types/models/browser-info';
import { post } from '../request';
import { ApiEndpoints } from '../apiEndpoints.constant';
import { APP_CONFIG } from '@/config';
import { Product, UpsellPurchaseResponse } from '@/@types/upsell';

export const upsellPurchase = async (product: Product, browserInfo: BrowserInfo) => {
  const url = new URL(`${APP_CONFIG.baseApiUrl}${ApiEndpoints.upsellPurchase}`);
  url.searchParams.append('product', product);

  return await post<UpsellPurchaseResponse, { browserInfo: BrowserInfo }>(url.toString(), { browserInfo: browserInfo });
};
